"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillStatusToJSON = exports.BillStatusFromJSONTyped = exports.BillStatusFromJSON = exports.BillStatus = void 0;
/**
 * The payment status of the given bill
 * @export
 */
exports.BillStatus = {
    Unknown: 'UNKNOWN',
    Paid: 'PAID',
    Unpaid: 'UNPAID'
};
function BillStatusFromJSON(json) {
    return BillStatusFromJSONTyped(json, false);
}
exports.BillStatusFromJSON = BillStatusFromJSON;
function BillStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.BillStatusFromJSONTyped = BillStatusFromJSONTyped;
function BillStatusToJSON(value) {
    return value;
}
exports.BillStatusToJSON = BillStatusToJSON;
